import {defined, evaluate} from '../utility/Control';
import {Token} from './model/Token';
import Debugger from '../utility/Debugger';
import {Response} from './model/Response';
import {Error} from './model/Error';
import ErrorHandler from '../utility/ErrorHandler';
import {stringify} from 'qs';
import axios from 'axios';
import {AxiosRequestConfig} from 'axios';
import {AxiosResponse} from 'axios';
import {AxiosError} from 'axios';
import {polyfill} from 'es6-promise';
import Config from '../utility/Config';
polyfill(); // if necessary, patch environment

declare var XDomainRequest;
const AUTH_BY_QS: boolean = typeof XDomainRequest !== 'undefined'; // UA IE <= 9, append authorization to query string

const AUTH_REQUEST_CONFIG: AxiosRequestConfig = {
  headers: {
    'Content-type': 'application/x-www-form-urlencoded'
  }
};

export class Inclusion {
  public params: any;

  constructor(public propertyName: string, public inclusions: Inclusion[], params?: any) {
    this.params = params || {};
  }
}

export function authenticate(
  client: string,
  username: string,
  password: string,
  onResponse: (token: Token) => void,
  onErr?: (error: Error) => void
  ): void {
    const data = {
        username,
        password,
        grant_type: 'password',
        client_id: client
    };

    axios.post(Config.authenticationUrl, stringify(data), AUTH_REQUEST_CONFIG).then((res: AxiosResponse) => {
        onResponse(res.data);
    }).catch((err: AxiosError) => {
        let handled = false;
        const error = evaluate(err, 'response.data.error');
        if (defined(error, onErr)) {
            handled = true;
            onErr(error);
        }
        if (!handled) {
            Debugger.print('Unhandled error:');
            Debugger.print(err);
        }
    });
}

export function fetch(
  resourceIdentifier: string,
  inclusions: Inclusion[],
  token: string,
  onResponse: (response: Response) => void,
  params?: any
  ): void {
    const url = Config.realtyUrl + '/' + resourceIdentifier;
    let root: any;
    get(url, params ? params : {}, inclusions, 'Bearer ' + token, (response: Response) => {
        root = response;
    }, () => {
        onResponse(root);
    });
}

function get(
  url: string,
  params: any,
  toInclude: Inclusion[],
  token: string,
  onResponse: (response: Response) => void,
  onComplete: () => any,
  requestCounter?: { count: number }
  ): void {
    if (!defined(requestCounter)) { // This is the root of the query
        requestCounter = {
            count: 0
        };
    }
    ++requestCounter.count;
    if (AUTH_BY_QS) {
        params.authorization = token;
    }
    axios.get(url, {
        params,
        headers: {
            Authorization: token
        }
    }).then((res: AxiosResponse) => {
        const response: Response = res.data;
        onResponse(response);
        if (!defined(response.error)) {
            const items = response.items ? response.items : [response.item];
            items.forEach((item: any) => {
                item.inclusions = {};
                toInclude.forEach((inclusion: Inclusion) => {
                    const href: string = evaluate(item, 'links.' + inclusion.propertyName + '.href');
                    if (defined(href)) {
                        get(href, inclusion.params, inclusion.inclusions, token, (resp: Response) => {
                            if (!defined(resp.error)) {
                                item.inclusions[inclusion.propertyName] = resp;
                            } else {
                                Debugger.print(resp.error);
                            }
                        }, onComplete, requestCounter);
                    } else {
                        Debugger.print('The property ' + inclusion.propertyName + ' is not defined for ' + url);
                    }
                });
            });
        }
        if (--requestCounter.count === 0) {
            onComplete();
        }
    }).catch((err: AxiosError) => {
        const error = evaluate(err, 'response.data.error');
        if (defined(error)) {
            ErrorHandler.handle(error);
        } else {
            ErrorHandler.handle(err);
        }
        if (--requestCounter.count === 0) {
            onComplete();
        }
    });
}



/** WEBPACK FOOTER **
 ** ./src/realty/Realty.ts
 **/